<template>
    <div class="custom-tree-container">
      <div style="display: flex; align-items: center; margin-bottom: 10px;" v-if="userRole.includes('超级管理员')">
        <el-button type="primary" size="small" @click="handleInsert()">{{ $t('valueChain.newV', { msg: 'valueChain.newV' }) }}</el-button>
        <!-- <el-button type="danger" size="small" @click="handleDelete()" style="margin-left: 10px;">删除能力域</el-button> -->
      </div>
      <el-tree
        v-loading="loading"
        :data="treeData"
        :props="{label: 'label', children: 'childrenList'}"
        :default-expand-all="false"
        font-size="30px"
      />

      <el-dialog v-model="insertDialog" :title="$t('valueChain.newV', { msg: 'valueChain.newV' })">
      <el-form :model="insertForm" label-width="130px" :data="insertForm" label-position="left" :rules="newPowerRule" ref="insertForm">
        <el-form-item :label="$t('valueChain.vcId', { msg: 'valueChain.vcId' })" prop="idValueChain" >
          <el-input v-model="insertForm.idValueChain" @blur="getParentId()" :placeholder="$t('valueChain.vcIdD', { msg: 'valueChain.vcIdD' })" ref="idValueChain"></el-input>
        </el-form-item>
        <el-form-item :label="$t('valueChain.fvcId', { msg: 'valueChain.fvcId' })" prop="idParent">
          <el-input v-model="insertForm.idParent" :disabled="idParentDisabled" ref="idParentRef" :placeholder="$t('valueChain.fvcIdD', { msg: 'valueChain.fvcIdD' })"></el-input>
        </el-form-item>
        <el-form-item :label="$t('valueChain.content', { msg: 'valueChain.content' })" prop="valueChain">
          <el-input v-model="insertForm.valueChain" :placeholder="$t('valueChain.contentD', { msg: 'valueChain.contentD' })"></el-input>
        </el-form-item>
        <!-- <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="insertForm.companyName" placeholder="请输入公司名称"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="跨级别设置">
          <el-switch v-model="insertForm.setup" @click="handleSwitch()" class="left-switch"></el-switch>
        </el-form-item> -->
        <el-form-item>
          <el-button type="primary" @click="insertValueChain('insertForm')">{{ $t('valueChain.new', { msg: 'valueChain.new' }) }}</el-button>
          <el-button type="danger" @click="handleInsertClose()">{{ $t('valueChain.cancel', { msg: 'valueChain.cancel' }) }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    </div>
  
      <!-- <el-dialog v-model="deleteDialog" title="删除能力域" align-center="true" draggable="true" width="40%">
        <el-form :model="deleteForm" label-width="100px" :data="deleteForm" label-position="center" :rules="deletePowerRule" ref="deleteForm">
          <el-form-item prop="id" :rules="{required: true, message: '能力域不能为空', trigger: 'blur'}">
            <el-select v-model="deleteForm.id" @change="deleteIdChanged()" clearable style="width: 400px;">
              <el-option v-for="item in level0"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
  
          <el-form-item prop="confirmId" :rules="{required: true, message: '能力域不能为空', trigger: 'blur'}">
            <el-select v-model="deleteForm.confirmId" @click="querySubLevel()" clearable style="width: 400px;">
              <el-option v-for="item in subLevel"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
  
          <el-form-item style="text-align: center;">
            <el-switch
              active-text="删除上下级关系"
              v-model="deleteForm.deleteRelation"
              style="--el-switch-on-color: #13ce66; --el-switch-off-color: #ff4949;margin: 0 auto;left: 74px"
              :active-value="1"
              :inactive-value="0"
              >
            </el-switch>
          </el-form-item> -->
        
          <!-- <el-form-item>
            <el-button type="primary" @click="deletePowerDomain('deleteForm')">删除</el-button>
            <el-button type="danger" @click="handleDeleteClose()">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog> -->
  
    </template>
    
    <script>
  import { baseUrl_New } from '../../axios/urlconfig';
  import axios from 'axios';
import { getRequest, postRequest } from '../../axios/axios';
    export default {
      data() {
        return {
          treeData: [],
          loading: true,
          insertDialog: false,
          deleteDialog: false,
          idParentDisabled: true,
          parentId: '',
          level0: [],
          subLevel: [],
          userRole:'',
  
          insertForm: {
            idValueChain: '',
            idParent: '',
            valueChain: '',
            companyName: '',
            setup: 0,
          },
  
          deleteForm: {
            id: '',
            confirmId: '',
            deleteRelation: '0',
          },
  
          newPowerRule: {
          idValueChain: [
          { required: true, message: this.$t('valueChain.vcIdP', { msg: 'valueChain.vcIdP' }), trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9-]*$/, message: this.$t('valueChain.info', { msg: 'valueChain.info' }), trigger: 'blur'}
          ],
          valueChain: [
            { required: true, message: this.$t('valueChain.contentP', { msg: 'valueChain.contentP' }), trigger: 'blur' }
          ],
          companyName: [
            { required: false, message: this.$t('valueChain.companyP', { msg: 'valueChain.companyP' }), trigger: 'blur' }
          ]
          },
  
        };
      },
  
      created() {
        this.fetchData();
        this.selectLevel0();
        this.getUserRole();
      },
  
      methods: {
  
        fetchData() {
          getRequest(baseUrl_New + '/chain/list')
          .then(response => {
             // console.log(response);
              this.treeData = response;
              this.loading = false;
          }).catch(err => {
              console.log(err);
          })
        },
  
        handleInsert(){
          this.insertDialog = true;
          this.$refs.id.onfocus = true;
        },
  
        handleInsertClose(){
          this.insertForm.idValueChain = '';
          this.insertForm.idParent = '';
          this.insertForm.valueChain = '';
          this.insertForm.companyName = '';
          this.insertForm.setup = false;
          this.insertDialog = false;
        },
  
        handleDelete(){
          this.deleteDialog = true;
        },
  
        handleDeleteClose(){
          this.deleteForm.id = '';
          this.deleteForm.confirmId = '';
          this.deleteForm.deleteRelation = '0';
          this.deleteDialog = false;
        },
  
        insertValueChain(formName){
          this.$refs[formName].validate((valid) => { 
          if (valid) {
          postRequest(baseUrl_New + "/chain/insert",this.insertForm).
          then(res => {
            if(res === "新增成功"){
              this.$message.success(this.$t('issue.addS', { msg: 'issue.addS' }));
              this.handleInsertClose();
              this.fetchData();
            }else{
              this.$message.error(res);
            }
          }).catch(err => {
            console.log(err);
          })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        },
  
        deletePowerDomain(formName){
          this.$refs[formName].validate((valid) => { 
          if (valid) {
          postRequest(baseUrl_New + "/power/delete",this.deleteForm)
          .then(res => {
            if(res === "删除成功"){
              this.$message.success(this.$t('issue.deleteS', { msg: 'issue.deleteS' }));
              this.handleDeleteClose();
              this.fetchData();
            }else {
              this.$message.error(this.$t('issue.deleteF', { msg: 'issue.deleteF' }));
            }
          }).catch(err => {
            this.$message.error(err);
            console.log(err);
          })
          }
        });
        },
  
        getParentId(){
          let result =  this.insertForm.idValueChain.substring(0,this.insertForm.idValueChain.lastIndexOf('-'));
          this.insertForm.idParent = result;
        },
  
        handleSwitch(){
          if(this.insertForm.setup === true){
            this.idParentDisabled = false;
          }else{
            this.idParentDisabled = true;
          }
        },
  
        selectLevel0(){
          getRequest(baseUrl_New + "/power/level0").
          then(res => {
            for(let i = 0;i < res.length; i++){
            this.level0.push({
              label: res[i],
              value: res[i],
              text: res[i]
            })
          }
          }).
          catch(err => {
            console.log(err);
          })
        },
  
        querySubLevel(){
          this.subLevel.splice(0,this.subLevel.length);
          getRequest(baseUrl_New + "/power/sublevel/" + this.deleteForm.id.split(':')[0]).
          then(res => {
            for(let i = 0;i < res.length; i++){
            this.subLevel.push({
              label: res[i],
              value: res[i],
              text: res[i]
            })
          }
          }).
          catch(err => {
            console.log(err);
          })
        },
  
        deleteIdChanged(){
          this.deleteForm.confirmId = '';
        },
        
        getUserRole(){
          this.userRole=sessionStorage.getItem('role');
        },


      }
    };
    </script>
  
  <style>
          
  /* 将开关靠左显示 */
  .el-switch {
    display: flex;
    align-items: center;
  }			
  
  /* 调整标签样式以对齐开关 */
  .el-form-item__label {
    line-height: 20px; /* 调整标签的行高 */
  }
  </style>
  